import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { api } from "../common/api";
import FormPage from "../common/FormPage";
import dayjs from "dayjs";
import { Button, DatePicker, Form, Input, Select, Space, Upload } from "antd";
import { filterOption, requiredField } from "../common/common";
import { UploadOutlined } from "@ant-design/icons";

export default function ({ document, ownerType, ownerId, returnPath }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(true);
  const [form] = Form.useForm();

  useEffect(() => {
    api.tag
      .list({ pageSize: 9999 })
      .then(({ data }) => setTags(data))
      .finally(() => setTagsLoading(false));
  }, []);

  useEffect(() => {
    if (document) {
      form.setFieldsValue({ ...document, tag: document.tag.id });
    }
  }, [document]);

  const onFinish = (values) => {
    const body = new FormData();
    body.append("name", values.name.trim());
    body.append("tag", values.tag);
    if (!document) {
      body.append("type", ownerType);
      if (ownerId != null) body.append("sourceId", ownerId);
      body.append("file", values.file[0].originFileObj ?? values.file[0]);
    }
    if (values.date) body.append("date", values.date);
    if (values.dueDate) body.append("dueDate", values.dueDate);
    setLoading(true);
    if (document)
      api.document
        .update(document.id, body)
        .then(() => navigate(returnPath ?? -1))
        .finally(() => setLoading(false));
    else
      api.document
        .create(body)
        .then(() => navigate(returnPath ?? -1))
        .finally(() => setLoading(false));
  };

  return (
    <FormPage
      title={`${document ? "Modifica" : "Nuovo"} documento`}
      onFinish={onFinish}
      form={form}
      initialValues={
        document
          ? {
              name: document.name,
              tag: document.tag?.id,
              date: document.date ? dayjs(document.date) : null,
              dueDate: document.dueDate ? dayjs(document.dueDate) : null,
            }
          : {}
      }
    >
      <Form.Item
        name="name"
        label="Nome"
        rules={[requiredField, { whitespace: true, message: "Inserisci un nome" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="tag" label="Tag" rules={[requiredField]}>
        <Select
          showSearch
          allowClear
          loading={tagsLoading}
          filterOption={filterOption}
          options={tags.map((tag) => ({ label: tag.name, value: tag.id }))}
        />
      </Form.Item>
      <Form.Item
        name="date"
        label="Data"
        getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        normalize={(value) => value?.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        name="dueDate"
        label="Scadenza"
        getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        normalize={(value) => value?.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
      {!document && (
        <Form.Item
          name="file"
          label={"File"}
          valuePropName="fileList"
          getValueFromEvent={(event) => event.fileList}
          rules={[{ ...requiredField, type: "array", min: 1 }]}
        >
          <Upload maxCount={1} beforeUpload={() => false}>
            <Button icon={<UploadOutlined />}>Seleziona file</Button>
          </Upload>
        </Form.Item>
      )}
      <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
        <Space>
          <Button disabled={loading} onClick={() => navigate(returnPath ?? -1)}>
            Annulla
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Salva
          </Button>
        </Space>
      </Form.Item>
    </FormPage>
  );
}
